import { render, staticRenderFns } from "./Kebijakan.vue?vue&type=template&id=49153c2e&scoped=true"
import script from "./Kebijakan.vue?vue&type=script&lang=js"
export * from "./Kebijakan.vue?vue&type=script&lang=js"
import style0 from "./Kebijakan.vue?vue&type=style&index=0&id=49153c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49153c2e",
  null
  
)

export default component.exports